const uniqueMergeArrays = (arr1, arr2) => {
  const newItems = arr2.filter(
    (item) => !arr1.some((option) => option.id == item.id)
  );
  return [...arr1, ...newItems];
};

export default uniqueMergeArrays;
